import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=4493962f&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=tsx&"
export * from "./Registration.vue?vue&type=script&lang=tsx&"
import style0 from "./Registration.vue?vue&type=style&index=0&id=4493962f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493962f",
  null
  
)

export default component.exports